function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 14.727V3.818a.92.92 0 01.26-.643c.196-.2.547-.439 1.077-.655.802-.33 1.83-.52 3.107-.52 1.26 0 2.118.25 3.886.974 1.566.64 2.263.844 3.226.844 1.056 0 1.86-.15 2.447-.39.304-.123.453-.225.48-.253.56-.572 1.517-.167 1.517.643v10.91a.92.92 0 01-.26.642c-.196.2-.547.44-1.077.656-.802.328-1.83.52-3.107.52-1.26 0-2.118-.251-3.886-.975-1.566-.64-2.263-.844-3.226-.844-1.056 0-1.86.15-2.447.39a3.598 3.598 0 00-.22.098v5.876A.9.9 0 015.89 22a.9.9 0 01-.89-.91v-6.363zm4.444-1.818c1.26 0 2.118.251 3.886.974 1.566.64 2.263.844 3.226.844 1.056 0 1.86-.15 2.447-.39.085-.034.158-.067.22-.097V5.276c-.729.23-1.614.36-2.667.36-1.26 0-2.118-.25-3.886-.974-1.566-.64-2.263-.844-3.226-.844-1.056 0-1.86.15-2.447.39a3.598 3.598 0 00-.22.097v8.964c.729-.23 1.614-.36 2.667-.36z"
});

var SvgFlag = function SvgFlag(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/flag.aac04b97.svg";
export { SvgFlag as ReactComponent };